<script setup>
import { inject } from 'vue';
import UiFormField from '@/components/ui/UiFormField.vue';
import SettingsSection from '@/components/settings/SettingsSection.vue';
import { SCHOOL_SETTINGS_KEY } from '@/composables/useSchoolSettingsForm';

const KEYS = ['depedSchoolId', 'address', 'district', 'division', 'region', 'contactPhone', 'contactEmail'];
const { form, saving, savedAt, isDirty, reset, save } = inject(SCHOOL_SETTINGS_KEY);

// Same checks as the API, so a bad value shows here instead of failing the save.
const phoneRule = (v) => !v || /^[0-9+()\-\s/]*$/.test(v) || 'Digits, spaces and + ( ) - / only';
const emailRule = (v) => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Enter a valid email address';
</script>

<template>
  <SettingsSection
    title="DepEd details"
    description="Printed on school forms and reports such as SF2, SF9, SF10 and Form 29."
    :dirty="isDirty(KEYS)"
    :saving="saving === 'deped'"
    :saved-at="savedAt.deped || 0"
    @save="save('deped', KEYS)"
    @reset="reset(KEYS)"
  >
    <div class="form-grid">
      <UiFormField label="School ID" v-slot="{ id }">
        <v-text-field :id="id" v-model="form.depedSchoolId" placeholder="e.g. 316401" maxlength="30" hide-details="auto" />
      </UiFormField>
      <UiFormField label="Region" v-slot="{ id }">
        <v-text-field :id="id" v-model="form.region" placeholder="e.g. Region XI" maxlength="100" hide-details="auto" />
      </UiFormField>
      <UiFormField label="Division" v-slot="{ id }">
        <v-text-field :id="id" v-model="form.division" placeholder="e.g. Panabo City" maxlength="100" hide-details="auto" />
      </UiFormField>
      <UiFormField label="District" v-slot="{ id }">
        <v-text-field :id="id" v-model="form.district" maxlength="100" hide-details="auto" />
      </UiFormField>
      <UiFormField label="Address" class="span-2" v-slot="{ id }">
        <v-text-field :id="id" v-model="form.address" maxlength="200" hide-details="auto" />
      </UiFormField>
      <UiFormField label="Phone" description="Printed in the Form 29 footer." v-slot="{ id }">
        <v-text-field
          :id="id"
          v-model="form.contactPhone"
          placeholder="e.g. 09302206174 / 09272506495"
          maxlength="100"
          :rules="[phoneRule]"
          hide-details="auto"
        />
      </UiFormField>
      <UiFormField label="Email" description="Printed in the Form 29 footer." v-slot="{ id }">
        <v-text-field
          :id="id"
          v-model="form.contactEmail"
          type="email"
          placeholder="e.g. school@deped.gov.ph"
          maxlength="150"
          :rules="[emailRule]"
          hide-details="auto"
        />
      </UiFormField>
    </div>
  </SettingsSection>
</template>
